import { rem } from 'polished'
import styled from 'styled-components'

import ClickableLink from 'components/Common/Clickable/ClickableLink'
import { cardItemHoverAnimation } from 'tripPlanner/utils/css'

export const FlightSearchCard = styled(ClickableLink)`
  border-radius: ${(props) => props.theme.borderRadius.M};
  border: 1px dashed ${({ theme }) => theme.palette.neutral.default.five};
  display: grid;
  grid-gap: ${rem(12)};
  padding: ${rem(16)};
  width: 100%;
  background-color: ${(props) => props.theme.palette.neutral.default.eight};
  break-inside: avoid-page;
  ${cardItemHoverAnimation}
`
